import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { DataService } from './data.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { isVetSource } from './utils/helper-functions';

const TOKEN_NAME = 'X-WIS-TOKEN';
const VET_TOKEN_NAME = 'Authorization'

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  errorCodes = [401,403]
  constructor(private dataService:DataService, private _router:Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    try{

 

    function getCookieValue(key:string) {
      let cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        let cookiePair = cookies[i].split('=');
        if (cookiePair[0].trim() === key)
          return cookiePair[1];
      }
      return '';
    }

    const buid = this.getQueryString('buid');
    const token = getCookieValue(`sso-wis-token-${buid}`);
    const isVet = isVetSource();
    const tokenHeaderName = isVet ? VET_TOKEN_NAME : TOKEN_NAME;

    let requestUrl = request.url;
    if (isVet) {
      if (requestUrl.startsWith(environment.CONFIGURATION_SERVICE_API)) {
        requestUrl = requestUrl.replace(environment.CONFIGURATION_SERVICE_API, environment.VET_CONFIG_URL);
      }
     else if (requestUrl.startsWith(environment.API_URL)) {
        requestUrl = requestUrl.replace(environment.API_URL, environment.VET_URL);
      }
    }

    const modifiedReq = request.clone(
      {
      url: requestUrl,
      setHeaders: { 
        ...(!!token && { [tokenHeaderName]: token }),
      },
    }
    );

    return next.handle(modifiedReq).pipe(
      tap(
      ()=>{},
      (err)=>{
        if(err instanceof HttpErrorResponse && (this.errorCodes.includes(err.status))){
          this._router.navigate(['error'])
        } if(err instanceof HttpErrorResponse && err.status === 500){
          alert('Request has not processed due to an internal server error!')
        }
      })
    )
  }catch(e){
    console.error("Interceptor Error!")
    return throwError('Interceptor error')
  }
  }

  getQueryString = function (field) {
    const href = window.location.href;
    const reg = new RegExp("[?&]" + field + "=([^&#]*)", "i");
    const string = reg.exec(href);
    return string ? string[1] : null;
  };
}
